import * as React from 'react';

import './stylings/WelcomeBanner.css';


export default function() {
	return (
		<section>
			
			<div className="mobile_info">
				<p>Leider ist unsere mobile Seite noch nicht 100% fertig. Wir arbeiten aber fleißg daran :) </p>
			</div>
			<div className="news">
				<div className="news__banner">
					<div className="container">
						<div className="news__banner-content">
							<h2>
								Willkommen bei Koblenz Kompass
							</h2>
							<p>
								Egal ob Bars, Restaurants, Clubs oder Freizeit. 
								Wir zeigen euch die empfehlenswertesten Lokalitäten 
								in Koblenz. 
							</p>
						</div>
					</div>
				</div>	
			</div>
		</section>
	);
}


// WEBPACK FOOTER //
// ./src/components/WelcomeBanner.js